module.exports = __webpack_public_path__ + "static/media/fraud.20171c7f.svg";